"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Icon = require("../../Icon");

var _Typography = require("../../Typography");

var _utilities = require("../../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["component", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledListItemButton = (0, _material.styled)(_material.ListItemButton)(function (_ref) {
  var _hoverFocus, _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "& .".concat(_utilities.classes.components.MuiTypography.root), {
    color: theme.palette.primary.main
  }), (0, _defineProperty2.default)(_ref2, "&.".concat(_utilities.classes.states.MuiFocusVisible), {
    border: "2px solid ".concat(theme.palette.focusRing.main),
    borderRadius: "3px",
    boxShadow: "0 2px 4px rgba(93,176,255,0.5)",
    padding: "calc(".concat(theme.spacing(2), " - 2px) calc(").concat(theme.spacing(3), " - 2px)"),
    zIndex: 1
  }), (0, _defineProperty2.default)(_ref2, "&:hover, &:focus", (_hoverFocus = {}, (0, _defineProperty2.default)(_hoverFocus, "& .".concat(_utilities.classes.components.MuiTypography.root), {
    color: theme.palette.primary.dark,
    textDecoration: "underline"
  }), (0, _defineProperty2.default)(_hoverFocus, "& .".concat(_utilities.classes.components.MuiListemItemIcon.root), {
    color: theme.palette.primary.dark
  }), (0, _defineProperty2.default)(_hoverFocus, "backgroundColor", "transparent"), _hoverFocus)), (0, _defineProperty2.default)(_ref2, "padding", "".concat(theme.spacing(2), " ").concat(theme.spacing(3))), _ref2;
});
var StyledListItemIcon = (0, _material.styled)(_material.ListItemIcon)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.primary.main,
    marginRight: theme.spacing(2),
    minWidth: "inherit"
  };
});

var Back = function Back(_ref4) {
  var component = _ref4.component,
      label = _ref4.label,
      props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ListItem, {
    disablePadding: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledListItemButton, _objectSpread(_objectSpread({
      "aria-label": label,
      component: component || "a",
      disableRipple: true,
      role: "link"
    }, props), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledListItemIcon, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          iconName: "chevron-left",
          size: "small"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ListItemText, {
        disableTypography: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
          variant: "body3",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: label
          })
        })
      })]
    }))
  });
};

var _default = Back;
exports.default = _default;